import React, { FunctionComponent } from "react";
import { IIconProps } from "../icon";

export const NutrientsDecreaseIcon: FunctionComponent<IIconProps> = (props) => {
  const { color, outlined, ...rest } = props;
  return (
    <svg viewBox="0 0 600 600" {...rest}>
      <defs>
        <style>{`.cls-nutrients-decrease-icon-1{fill:${
          color ?? "#931658"
        };}.cls-nutrients-decrease-icon-2{fill:#fff;}`}</style>
      </defs>
      <path
        className="cls-nutrients-decrease-icon-1"
        d="M328.31,510.68,552.71,122c12.58-21.79-3.15-49-28.31-49H75.6c-25.16,0-40.89,27.25-28.31,49l224.4,388.67C284.27,532.47,315.73,532.47,328.31,510.68Z"
      />
      <path
        className="cls-nutrients-decrease-icon-2"
        d="M413.86,214.87v16A17.92,17.92,0,0,1,396,248.75H326.14a.26.26,0,0,0-.26.26H274.12a.26.26,0,0,0-.26-.26H204a17.92,17.92,0,0,1-17.87-17.86v-16A17.92,17.92,0,0,1,204,197h69.85a.25.25,0,0,0,.26-.26h51.76a.25.25,0,0,0,.26.26H396A17.92,17.92,0,0,1,413.86,214.87Z"
      />
    </svg>
  );
};
